import BaseProductItemModel from 'coreClasses/lineItemCtnr/ProductItemModel';

/**
 * Represents ProductItemModel
 */
class ProductItemModel extends BaseProductItemModel {}

export default ProductItemModel;